import { FC } from 'react';
import V2Tag, { V2TagProps } from '@/common/components/Data/V2Tag';
import { Tooltip } from 'antd';
import { isNotEmpty } from '@lhb/func';

interface TagProps extends V2TagProps {
  /** 文本 */
  label: string,
  /** tooltip 提示文本 */
  tip?: string
}

/**
 * 标签组
 * @description 标签数组组件，Tag 标签属性基于 <a href="https://reactpc.lanhanba.net/components/Data/v2tag" target="_blank">标签 Tag</a>。
 * @category Data
 * @demo
  import TagGroup from 'src/common/components/TagGroup/index';

  <TagGroup size="small" :tags="expenseTags"/>
 */
const Component: FC<{
  /** 标签类型，默认使用 tags 内的标签；如果没有，则使用 color */
  color?: string,
  /** 标签数组，Tag 标签属性基于 <a href="https://reactpc.lanhanba.net/components/Data/v2tag" target="_blank">标签 Tag</a>。
    <br/>
    TagProps: { label: 标签文本, tip: tooltip 提示文本 }
   */
  tags: TagProps[],
  className?: string,
}> = ({ color, tags = [], className }) => {

  return (Array.isArray(tags) && !!tags.length ? <div className={className}>
    {tags.map((item, index) => (isNotEmpty(item.tip) ? <Tooltip key={index} placement='top' title={item.tip}>
      <span><V2Tag color={item.color || color} {...item}>{item.label}</V2Tag></span>
    </Tooltip> : <V2Tag key={index} color={item.color || color} {...item}>{item.label}</V2Tag>))}
  </div> : <></>);
};

export default Component;
